<div id="confirmationModal">
    <div class="modal-header">
        <h4>{{title}}</h4>
    </div>
    <div class="modal-body">
        <div [innerHTML]=description></div>
    </div>

    <div class="modal-footer">
        <button type="button" class="button" (click)="modalRef.hide()">{{ buttonsTitle.dismiss }}</button>
        <button type="button" class="button blue"
            (click)="clikedonConfirmation($event)">{{ buttonsTitle.confirm }}</button>
    </div>
</div>